import { render } from "./FilmBookmark.vue?vue&type=template&id=5a05356f&scoped=true"
import script from "./FilmBookmark.vue?vue&type=script&lang=js"
export * from "./FilmBookmark.vue?vue&type=script&lang=js"

import "./FilmBookmark.vue?vue&type=style&index=0&id=5a05356f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a05356f"]])

export default __exports__